import type { GhostAuthor, SelectResultFn } from "../../types";
import AuthorAvatar from "./AuthorAvatar";

interface AuthorListItemProps {
  author: GhostAuthor;
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function AuthorListItem({
  author,
  selectedResult,
  setSelectedResult,
}: AuthorListItemProps) {
  const { name, profile_image: profileImage, url, id } = author;
  let className =
    "py-[1rem] -mx-4 sm:-mx-7 px-4 sm:px-7 cursor-pointer flex items-center";
  if (id === selectedResult) {
    className += " bg-neutral-100";
  }
  return (
    <div
      className={className}
      onClick={() => {
        if (url) {
          window.location.href = url;
        }
      }}
      onMouseEnter={() => setSelectedResult(id)}
    >
      <AuthorAvatar name={name} avatar={profileImage} />
      <h2 className="text-[1.65rem] font-medium leading-tight text-neutral-900 truncate">
        {name}
      </h2>
    </div>
  );
}
